(() => {
  if (window.chaseGalleryAutoplay) return;
  window.chaseGalleryAutoplay = true;
  if (!('IntersectionObserver' in window)) return;

  const states = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const pause = state => {
    const video = state.element.querySelector('video');
    if (!video || video.paused) return;
    state.controllerPause = true;
    video.pause();
  };

  const bindVideo = (state, video) => {
    if (state.video === video) return;
    state.video = video;
    video.addEventListener('pause', () => {
      if (state.visible && !document.hidden && !state.controllerPause) state.userPaused = true;
      state.controllerPause = false;
    });
    video.addEventListener('play', () => {
      state.userPaused = false;
    });
  };

  const play = state => {
    if (!state.visible || document.hidden || reducedMotion.matches || state.userPaused) return;
    let video = state.element.querySelector('video');
    if (!video) {
      const source = state.element.querySelector('template')?.content.querySelector('video');
      if (!source) return;
      video = source.cloneNode(true);
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = true;
      state.element.setAttribute('loaded', 'true');
      bindVideo(state, video);
      state.element.appendChild(video);
    } else {
      bindVideo(state, video);
    }
    if (video.paused) video.play().catch(() => {});
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = states.get(entry.target);
      if (!state) return;
      const bounds = entry.boundingClientRect;
      const visible = entry.isIntersecting &&
        entry.intersectionRect.width >= bounds.width * 0.6 &&
        entry.intersectionRect.height >= Math.min(150, bounds.height * 0.25);
      state.visible = visible;
      if (visible) play(state);
      else {
        state.userPaused = false;
        pause(state);
      }
    });
  }, {threshold: [0, 0.1, 0.25, 0.5, 0.6, 0.75, 1]});

  const init = root => {
    root.querySelectorAll('[id^="MainProduct-"] media-gallery deferred-media[data-chase-gallery-autoplay]').forEach(element => {
      if (states.has(element)) return;
      const state = {element, visible: false, userPaused: false, controllerPause: false};
      states.set(element, state);
      const video = element.querySelector('video');
      if (video) bindVideo(state, video);
      observer.observe(element);
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => {
    for (const [element, state] of states) {
      if (element.isConnected) continue;
      pause(state);
      observer.unobserve(element);
      states.delete(element);
    }
  });
  document.addEventListener('visibilitychange', () => {
    states.forEach(state => document.hidden ? pause(state) : play(state));
  });
  window.addEventListener('pagehide', () => states.forEach(pause));
  window.addEventListener('pageshow', () => states.forEach(play));
  reducedMotion.addEventListener('change', () => {
    states.forEach(state => reducedMotion.matches ? pause(state) : play(state));
  });
})();
